<template>
  <header :class="{isIos: 'iosHeight'}" id="navBar">
    <nav>
    <!-- <nav @click="$router.back()"> -->
      <md-icon name="arrow-left" size="lg" @click="goBack" />
    </nav>
    <h1 >{{$route.meta.title1 || $t($route.meta.title)}}</h1>
    <div class="rightArea">
      <span class="span1" v-if="$route.meta.title === 'title.title4'" @click="setFilters">{{$t('label.label82')}}</span>
      <span class="span1" v-if="$route.meta.title === 'title.title0'" @click="toMyPosition">{{$t('label.label41')}}</span>
    </div>
  </header>
</template>

<script>
import { Icon } from '@gidc/mobile'
import dataCenterBus from '../assets/dataCenterBus'
export default {
  name: 'NavBar',
  props: {
    isIos: {
      type: Boolean,
      default: false
    }
  },
  components: {
    [Icon.name]: Icon
  },
  data: function () {
    return {
    }
  },
  methods: {
    goBack () {
      if ((this.$route.name === 'transactionResult' || this.$route.name === 'withdrawResult') && this.$route.meta.result) {
        this.$router.push('myPosition')
      } else if (this.$route.name === 'myPosition') {
        this.$router.push('ProductCategories')
      } else if (this.$route.name === 'ProductCategories') {
        this.$router.push('homePage')
      } else if (this.$route.name === 'tradingRecord') {
        this.$router.push('myPosition')
      } else if (this.$route.name === 'myPosition') {
        this.$router.push('homePage')
      } else {
        this.$router.back()
      }
    },
    setFilters () {
      dataCenterBus.$emit('myFun', true) // $emit这个方法会触发一个事件
    },
    toMyPosition () {
      this.$router.push({ name: 'myPosition', params: { path: 'ProductCategories' } })
    }
  }

}
</script>
<style lang="stylus">
  #navBar{
    .md-icon.icon-font:before{
      z-index 5
    }
  }
</style>
<style lang="stylus" scoped>

  #navBar
    width 100vw
    height .88rem
    border-bottom 1px solid rgb(239,238,244)
    display flex
    align-items center
    position sticky
    top 0
    z-index 10000
    background-color white
    justify-content space-between
    box-shadow : 0 .02rem .08rem rgba(233,233,233,0.5)
  iosHeight
    height 1rem
  header nav
    height .66rem
    width .66rem
    display flex
    align-items center
    justify-content center
    color rgb(85,85,85)
    z-index 5

  header h1
    font-size .34rem
    color rgb(85,85,85)
    text-align center
    position absolute
    top 50%
    left 50%
    transform translate(-50%,-50%)
    white-space nowrap
  header .rightArea
    width 1.5rem
    height .88rem
    position relative
  header .img1
    width .4rem
    height .4rem
    position absolute
    top 50%
    left   70%
    transform translate(-50%,-50%)
  header .span1
    font-size .28rem
    color rgba(58, 86, 216, 1)
    white-space nowrap
    position absolute
    top 50%
    left 50%
    transform translate(-50%,-50%)
</style>
